import {
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  Values,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import DateControl from "../../Components/DateControl";
import React, { useState, useContext, useEffect, useRef } from "react";
import InfoPopUp from "../../Components/InfoPopUp";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  applySidebarState,
  toggleSidebar,
  IsDateBefore,
  IsDateAfter,
} from "../../Helpers/Utilities";
import CustomTextArea from "../../Components/CustomTextArea ";

import {
  CommonError_Msgs,
  zeroToTwelve,
  zeroToThree,
  fourToFifteen,
  sixteenToTwentySeven,
} from "../../Helpers/HelperText";
import { laboratoryAssessmentService } from "../../WebApiServices/LaboratoryAssessmentService";
import ErrorField from "../../Components/ErrorField";
import { Dropdown } from "react-bootstrap";

const MMALabAssessment = () => {
  const navigatePaths = {
    prevPage: "/NonMDETreatment",
    currPage: "/MMALabAssessment",
    nextPage: "/ValidateSubmit?part=1",
  };

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setisSideMenuActive,
  } = useContext(AppContext);

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);

  const pidRef = useRef(0);
  let loggedInUserId = GetLoggedInUserID();

  let dates = GetLocalStorageData("ClinicalCharacteristicsDates") || {};



  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);


  ///Belinda
  const [showHide012HyperlinkModal, setShowHide012HyperlinkModal] =
    useState(false);
  const [showHide03HyperlinkModal, setShowHide03HyperlinkModal] =
    useState(false);
  const [showHide415HyperlinkModal, setShowHide415HyperlinkModal] =
    useState(false);
  const [showHide1627HyperlinkModal, setShowHide1627HyperlinkModal] =
    useState(false);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [patientLocked, setpatientLocked] = useState(false);


  //#region Q31
  const [labbiomarkerassessmentDetails, setlabbiomarkerassessmentDetails] =
    useState([
      {
        labbiomarkerassessmentid: 0,
        assessmentnumber: 1,
        biomarker: "",
        startAssessment: "",
        startAssessment_dt: "",
        startAssessment_dt_estimated: false,
        startAssessmentUnkLTLKT: "",
        specimen: "",

        blood_measurement: "",
        blood_measurement_value_l: "",
        blood_measurement_value_ml: "",
        blood_measurement_value_nl: "",
        blood_measurement_value_ng: "",
        urine_measurement: "",
        urine_measurement_value_l: "",
        urine_measurement_value_ml: "",
        urine_measurement_value_nl: "",
        urine_measurement_value_ng: "",
        urine_measurement_value_mmol: "",
        creatinine_measurement: "",
        creatinine_measurement_value_l: "",
        creatinine_measurement_value_ml: "",
        creatinine_measurement_value_nl: "",
        creatinine_measurement_value_dl: "",

        q31biomarkerEmpty: false,
        q31assessmentEmpty: false,
        q31specimenEmpty: false,
        q31measurementEmpty: false,
        q31assessmentDateEmptyError: false,
        q31assessmentDateInvalid: false,
        q31AssessmentDateUnkEmpty: false,
        q31measurementCSFEmpty: false,
        q31measurementUrineEmpty: false,
        q31measurementCreatinineEmpty: false,
        q31measurementInvalid: false,
        q31measurementUrineInvalid: false,
        q31measurementCreatinineInvalid: false,
      },
    ]);

  function addbiomarkerassessmentRow(e) {
    setlabbiomarkerassessmentDetails((prev) => [
      ...prev,
      {
        labbiomarkerassessmentid: 0,
        assessmentnumber: 1,
        biomarker: "",
        startAssessment: "",
        startAssessment_dt: "",
        startAssessment_dt_estimated: false,
        startAssessmentUnkLTLKT: "",
        specimen: "",

        blood_measurement: "",
        blood_measurement_value_l: "",
        blood_measurement_value_ml: "",
        blood_measurement_value_nl: "",
        blood_measurement_value_ng: "",
        urine_measurement: "",
        urine_measurement_value_l: "",
        urine_measurement_value_ml: "",
        urine_measurement_value_nl: "",
        urine_measurement_value_ng: "",
        urine_measurement_value_mmol: "",
        creatinine_measurement: "",
        creatinine_measurement_value_l: "",
        creatinine_measurement_value_ml: "",
        creatinine_measurement_value_nl: "",
        creatinine_measurement_value_dl: "",

        q31biomarkerEmpty: false,
        q31assessmentEmpty: false,
        q31specimenEmpty: false,
        q31measurementEmpty: false,
        q31assessmentDateEmptyError: false,
        q31assessmentDateInvalid: false,
        q31AssessmentDateUnkEmpty: false,
        q31measurementCSFEmpty: false,
        q31measurementUrineEmpty: false,
        q31measurementCreatinineEmpty: false,
        q31measurementInvalid: false,
        q31measurementUrineInvalid: false,
        q31measurementCreatinineInvalid: false,
      },
    ]);
  }

  function deleteBiomarkerAssessmentDetails(id) {
    const newBiomarkerAssessmentDetailsArray = [
      ...labbiomarkerassessmentDetails,
    ];
    newBiomarkerAssessmentDetailsArray.splice(id, 1);
    setlabbiomarkerassessmentDetails(newBiomarkerAssessmentDetailsArray);
  }
  //#endregion


  const HandleBioFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);
    const types = splitNameArray[2];

    const settingindex =
      types === "settingcare"
        ? parseInt(splitNameArray[3], 10)
        : types === "mde"
        ? parseInt(splitNameArray[3], 10)
        : "";
    const textindex =
      types === "settingcare"
        ? parseInt(splitNameArray[4], 10)
        : types === "mde"
        ? parseInt(splitNameArray[4], 10)
        : "";
    if (types === "bio") {
      //Q31
      setlabbiomarkerassessmentDetails((prevDetails) => {
        let updatedDetails = prevDetails.map((item, idx) => {
          if (idx === index) {
            let updatedItem = {
              ...item,
              [fieldName]:
                type === "checkbox"
                  ? checked
                  : type === "radio" && fieldName !== "rvUnknown"
                  ? parseInt(value, 10) || 0
                  : value,
            };

            if (fieldName === "biomarker")
              updatedItem.q31biomarkerEmpty = false;

            if (fieldName === "startAssessment") {
              if (parseInt(value, 10) === Values.value99) {
                updatedItem.startAssessment_dt = "";
                updatedItem.startAssessment_dt_estimated = false;
                updatedItem.startAssessmentUnkLTLKT = "";
                updatedItem.q31assessmentEmpty = false;
                updatedItem.q31assessmentDateEmptyError = false;
                updatedItem.q31assessmentDateInvalid = false;
                updatedItem.q31AssessmentDateUnkEmpty = false;
              } else {
                updatedItem.startAssessmentUnkLTLKT = "";
                updatedItem.q31assessmentEmpty = false;
              }
            }

            if (fieldName === "startAssessmentUnkLTLKT") {
              updatedItem.startAssessmentUnkLTLKT = parseInt(value, 10);
              updatedItem.startAssessment_dt = "";
              updatedItem.startAssessment_dt_estimated = false;
              updatedItem.startAssessment = 99;
              updatedItem.q31assessmentEmpty = false;
              updatedItem.q31assessmentDateEmptyError = false;
              updatedItem.q31assessmentDateInvalid = false;
              updatedItem.q31AssessmentDateUnkEmpty = false;
            } else if (fieldName === "startAssessment_dt_estimated") {
              updatedItem.startAssessment = 1;
              updatedItem.startAssessmentUnkLTLKT = "";
              updatedItem.q31assessmentEmpty = false;
              updatedItem.q31assessmentDateEmptyError = false;
              updatedItem.q31assessmentDateInvalid = false;
              updatedItem.q31AssessmentDateUnkEmpty = false;
            }

            if (fieldName === "blood_measurement" && item.specimen !== 1) {
              if (parseInt(value, 10) === Values.value99) {
                updatedItem.blood_measurement_value_l = "";
                updatedItem.blood_measurement_value_ml = "";
                  updatedItem.blood_measurement_value_nl = "";
                  updatedItem.blood_measurement_value_ng = "";
              } else {
                updatedItem.blood_measurement_value_l = "";
                updatedItem.blood_measurement_value_ml = "";
                  updatedItem.blood_measurement_value_nl = "";
                  updatedItem.blood_measurement_value_ng = "";
              }
              updatedItem.q31measurementEmpty = false;
              updatedItem.q31measurementUrineEmpty = false;
              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementCreatinineInvalid = false;
            }

            if (fieldName === "blood_measurement_value_l") {
              updatedItem.blood_measurement_value_l = value;
              updatedItem.blood_measurement = 1;
              updatedItem.blood_measurement_value_ml = "";
                updatedItem.blood_measurement_value_nl = "";
                updatedItem.blood_measurement_value_ng = "";
              updatedItem.q31measurementCSFEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementEmpty = false;
            } else if (fieldName === "blood_measurement_value_ml") {
              updatedItem.blood_measurement_value_ml = value;
              updatedItem.blood_measurement = 2;
              updatedItem.blood_measurement_value_l = "";
                updatedItem.blood_measurement_value_nl = "";
                updatedItem.blood_measurement_value_ng = "";
              updatedItem.q31measurementCSFEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementEmpty = false;
            }
            if (fieldName === "blood_measurement_value_nl") {
              updatedItem.blood_measurement_value_nl = value;
              updatedItem.blood_measurement = 3;
              updatedItem.blood_measurement_value_l = "";
                updatedItem.blood_measurement_value_ml = "";
                updatedItem.blood_measurement_value_ng = "";
              updatedItem.q31measurementCSFEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementEmpty = false;
              }
              if (fieldName === "blood_measurement_value_ng") {
                  updatedItem.blood_measurement_value_l = "";
                  updatedItem.blood_measurement = 4;
                  updatedItem.blood_measurement_value_ml = "";
                  updatedItem.blood_measurement_value_nl = "";
                  updatedItem.blood_measurement_value_ng = value;
                  updatedItem.q31measurementCSFEmpty = false;
                  updatedItem.q31measurementInvalid = false;
                  updatedItem.q31measurementEmpty = false;
              }

            if (fieldName === "urine_measurement" && item.specimen === 1) {
              if (parseInt(value, 10) === Values.value99) {
                updatedItem.urine_measurement_value_l = "";
                updatedItem.urine_measurement_value_ml = "";
                  updatedItem.urine_measurement_value_nl = "";
                  updatedItem.urine_measurement_value_ng = "";
                  updatedItem.urine_measurement_value_mmol = "";
              } else {
                updatedItem.urine_measurement_value_l = "";
                updatedItem.urine_measurement_value_ml = "";
                  updatedItem.urine_measurement_value_nl = "";
                  updatedItem.urine_measurement_value_ng = "";
                  updatedItem.urine_measurement_value_mmol = "";
              }
              if (item.creatinine_measurement !== "")
                updatedItem.q31measurementEmpty = false;
              updatedItem.q31measurementCSFEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementCreatinineInvalid = false;
            }
            if (fieldName === "urine_measurement_value_l") {
              updatedItem.urine_measurement_value_l = value;
              updatedItem.urine_measurement = 1;
              updatedItem.urine_measurement_value_ml = "";
                updatedItem.urine_measurement_value_nl = "";
                updatedItem.urine_measurement_value_ng = "";
                updatedItem.urine_measurement_value_mmol = "";
              updatedItem.q31measurementUrineEmpty = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            } else if (fieldName === "urine_measurement_value_ml") {
              updatedItem.urine_measurement_value_ml = value;
              updatedItem.urine_measurement = 2;
              updatedItem.urine_measurement_value_l = "";
                updatedItem.urine_measurement_value_nl = "";
                updatedItem.urine_measurement_value_ng = "";
                updatedItem.urine_measurement_value_mmol = "";
              updatedItem.q31measurementUrineEmpty = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            }
            if (fieldName === "urine_measurement_value_nl") {
              updatedItem.urine_measurement_value_nl = value;
              updatedItem.urine_measurement = 3;
              updatedItem.urine_measurement_value_l = "";
                updatedItem.urine_measurement_value_ml = "";
                updatedItem.urine_measurement_value_ng = "";
                updatedItem.urine_measurement_value_mmol = "";
              updatedItem.q31measurementUrineEmpty = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            }
              if (fieldName === "urine_measurement_value_ng") {
                  updatedItem.urine_measurement_value_nl = "";
                  updatedItem.urine_measurement = 4;
                  updatedItem.urine_measurement_value_l = "";
                  updatedItem.urine_measurement_value_ml = "";
                  updatedItem.urine_measurement_value_ng = value;
                  updatedItem.urine_measurement_value_mmol = "";
                  updatedItem.q31measurementUrineEmpty = false;
                  updatedItem.q31measurementUrineInvalid = false;
                  updatedItem.q31measurementEmpty = false;
              }

              if (fieldName === "urine_measurement_value_mmol") {
                  updatedItem.urine_measurement_value_nl = "";
                  updatedItem.urine_measurement = 5;
                  updatedItem.urine_measurement_value_l = "";
                  updatedItem.urine_measurement_value_ml = "";
                  updatedItem.urine_measurement_value_ng = "";
                  updatedItem.urine_measurement_value_mmol = value;
                  updatedItem.q31measurementUrineEmpty = false;
                  updatedItem.q31measurementUrineInvalid = false;
                  updatedItem.q31measurementEmpty = false;
              }
            if (fieldName === "creatinine_measurement" && item.specimen === 1) {
              if (parseInt(value, 10) === Values.value99) {
                updatedItem.creatinine_measurement_value_l = "";
                updatedItem.creatinine_measurement_value_ml = "";
                updatedItem.creatinine_measurement_value_nl = "";
                updatedItem.creatinine_measurement_value_dl = "";
              } else {
                updatedItem.creatinine_measurement_value_l = "";
                updatedItem.creatinine_measurement_value_ml = "";
                updatedItem.creatinine_measurement_value_nl = "";
                updatedItem.creatinine_measurement_value_dl = "";
              }
              if (item.urine_measurement !== "")
                updatedItem.q31measurementEmpty = false;
              updatedItem.q31measurementCSFEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementCreatinineInvalid = false;
            }

            if (fieldName === "creatinine_measurement_value_l") {
              updatedItem.creatinine_measurement_value_l = value;
              updatedItem.creatinine_measurement = 1;
              updatedItem.creatinine_measurement_value_ml = "";
              updatedItem.creatinine_measurement_value_nl = "";
              updatedItem.creatinine_measurement_value_dl = "";

              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementCreatinineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            } else if (fieldName === "creatinine_measurement_value_ml") {
              updatedItem.creatinine_measurement_value_ml = value;
              updatedItem.creatinine_measurement = 2;
              updatedItem.creatinine_measurement_value_l = "";
              updatedItem.creatinine_measurement_value_nl = "";
              updatedItem.creatinine_measurement_value_dl = "";

              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementCreatinineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            }
            if (fieldName === "creatinine_measurement_value_nl") {
              updatedItem.creatinine_measurement_value_nl = value;
              updatedItem.creatinine_measurement = 3;
              updatedItem.creatinine_measurement_value_l = "";
              updatedItem.creatinine_measurement_value_ml = "";
              updatedItem.creatinine_measurement_value_dl = "";

              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementCreatinineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            }

            if (fieldName === "creatinine_measurement_value_dl") {
              updatedItem.creatinine_measurement_value_dl = value;
              updatedItem.creatinine_measurement = 4;
              updatedItem.creatinine_measurement_value_l = "";
              updatedItem.creatinine_measurement_value_ml = "";
              updatedItem.creatinine_measurement_value_nl = "";
              
              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementCreatinineInvalid = false;
              updatedItem.q31measurementEmpty = false;
            }


            if (fieldName === "specimen" && item.specimen !== 1) {
              updatedItem.urine_measurement_value_l = "";
              updatedItem.urine_measurement_value_ml = "";
              updatedItem.urine_measurement_value_nl = "";
              updatedItem.urine_measurement = "";

              updatedItem.creatinine_measurement_value_l = "";
              updatedItem.creatinine_measurement_value_ml = "";
              updatedItem.creatinine_measurement_value_nl = "";
              updatedItem.creatinine_measurement_value_dl = "";

              updatedItem.creatinine_measurement = "";
              updatedItem.q31specimenEmpty = false;
              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementUrineEmpty = false;
            } else if (fieldName === "specimen" && item.specimen === 1) {
              updatedItem.blood_measurement_value_nl = "";
              updatedItem.blood_measurement = "";
              updatedItem.blood_measurement_value_l = "";
              updatedItem.blood_measurement_value_ml = "";
              updatedItem.q31specimenEmpty = false;
              updatedItem.q31measurementCSFEmpty = false;
            }

            if (
              fieldName === "biomarker" &&
              parseInt(value, 10) === Values.value4
            ) {
              updatedItem.startAssessment_dt = "";
              updatedItem.startAssessment_dt_estimated = false;
              updatedItem.startAssessmentUnkLTLKT = "";
              updatedItem.startAssessment = "";

              updatedItem.blood_measurement_value_l = "";
              updatedItem.blood_measurement_value_ml = "";
              updatedItem.blood_measurement_value_nl = "";
              updatedItem.blood_measurement = "";
              updatedItem.specimen = "";

              updatedItem.urine_measurement_value_l = "";
              updatedItem.urine_measurement = "";
              updatedItem.urine_measurement_value_ml = "";
              updatedItem.urine_measurement_value_nl = "";

              updatedItem.creatinine_measurement_value_l = "";
              updatedItem.creatinine_measurement = "";
              updatedItem.creatinine_measurement_value_ml = "";
              updatedItem.creatinine_measurement_value_nl = "";
              updatedItem.creatinine_measurement_value_dl = "";


              updatedItem.q31biomarkerEmpty = false;
              updatedItem.q31assessmentEmpty = false;
              updatedItem.q31specimenEmpty = false;
              updatedItem.q31measurementEmpty = false;
              updatedItem.q31assessmentDateEmptyError = false;
              updatedItem.q31assessmentDateInvalid = false;
              updatedItem.q31AssessmentDateUnkEmpty = false;
              updatedItem.q31measurementCSFEmpty = false;
              updatedItem.q31measurementUrineEmpty = false;
              updatedItem.q31measurementCreatinineEmpty = false;
              updatedItem.q31measurementInvalid = false;
              updatedItem.q31measurementUrineInvalid = false;
              updatedItem.q31measurementCreatinineInvalid = false;
            }

            return updatedItem;
          }
          return item;
        });

        if (
          fieldName === "biomarker" &&
          parseInt(value, 10) === Values.value4 &&
          updatedDetails.length > 1
        ) {
          updatedDetails = [updatedDetails[0]]; // Keep only the first entry
        }

        return updatedDetails;
      });
    }

  }


 
  const HandleDateChange = (name, date, optionId, index) => {
    const lastIndex = name.lastIndexOf("-");
    const idx = name.slice(lastIndex + 1);

    switch (optionId) {
      case "startAssessment_dt":
        {
          let Q31array = [...labbiomarkerassessmentDetails];
          Q31array[idx][optionId] = date;
          Q31array[idx].startAssessment = 1;
          Q31array[idx].startAssessmentUnkLTLKT = "";
          Q31array[idx].q31assessmentDateEmptyError = false;
          Q31array[idx].q31assessmentEmpty = false;
          setlabbiomarkerassessmentDetails(Q31array);
        }
        break;
    default:
        break;
    }
  };

  useEffect(() => {

    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await GetLabData();
      
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const GetLabData = async () => {
    try {
      const response = await laboratoryAssessmentService.LoadMMALabData(
        pidRef.current,
        loggedInUserId
      );
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);

        //#region  Q31
        if (
          data.labBiomarkerAssessmenListDetails !== null &&
          data.labBiomarkerAssessmenListDetails.length > 0
        ) {
          let i = 0;
          let dataarray = [];

          for (i; i < data.labBiomarkerAssessmenListDetails.length; i++) {
            const detailsStart = data.labBiomarkerAssessmenListDetails[i];
            const assessmentUnkStart =
              detailsStart.assessmentStartDateUnknown ?? "";

            const startBiomarkerUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT &&
                assessmentUnkStart === Values.value1) ||
              (!dates?.zero_to_3months_after_LT_LKT &&
                assessmentUnkStart === Values.value2) ||
              (!dates?.four_to_15months_after_LT_LKT &&
                assessmentUnkStart === Values.value3) ||
              (!dates?.sixteen_to_27months_after_LT_LKT &&
                assessmentUnkStart === Values.value4)
                ? ""
                : assessmentUnkStart;

            let datacomponent = {
              labbiomarkerassessmentid:
                data.labBiomarkerAssessmenListDetails[i]
                  .labBiomarkerAssessmentID !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .labBiomarkerAssessmentID
                  : 0,
              assessmentnumber:
                data.labBiomarkerAssessmenListDetails[i].assessmentNumber,
              biomarker:
                data.labBiomarkerAssessmenListDetails[i].bioMarker !== null
                  ? data.labBiomarkerAssessmenListDetails[i].bioMarker
                  : "",

              startAssessment:
                data.labBiomarkerAssessmenListDetails[i].assessmentStart !==
                null
                  ? data.labBiomarkerAssessmenListDetails[i].assessmentStart
                  : "",
              startAssessment_dt:
                data.labBiomarkerAssessmenListDetails[i].assessmentStartDate !==
                null
                  ? data.labBiomarkerAssessmenListDetails[i].assessmentStartDate
                  : "",
              startAssessment_dt_estimated:
                data.labBiomarkerAssessmenListDetails[i]
                  .assessmentStartDateEstimated !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .assessmentStartDateEstimated
                  : false,
              startAssessmentUnkLTLKT: startBiomarkerUnkLTLKT,

              specimen:
                data.labBiomarkerAssessmenListDetails[i].specimen !== null
                  ? data.labBiomarkerAssessmenListDetails[i].specimen
                  : "",

              blood_measurement:
                data.labBiomarkerAssessmenListDetails[i].bloodMeasurement !==
                null
                  ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurement
                  : "",

              blood_measurement_value_l:
                data.labBiomarkerAssessmenListDetails[i]
                  .bloodMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .bloodMeasurement === 1
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .bloodMeasurementValue
                    : ""
                  : "",

              blood_measurement_value_ml:
                data.labBiomarkerAssessmenListDetails[i]
                  .bloodMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .bloodMeasurement === 2
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .bloodMeasurementValue
                    : ""
                  : "",

              blood_measurement_value_nl:
                data.labBiomarkerAssessmenListDetails[i]
                  .bloodMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .bloodMeasurement === 3
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .bloodMeasurementValue
                    : ""
                  : "",
                blood_measurement_value_ng:
                    data.labBiomarkerAssessmenListDetails[i]
                        .bloodMeasurementValue !== null
                        ? data.labBiomarkerAssessmenListDetails[i]
                            .bloodMeasurement === 4
                            ? data.labBiomarkerAssessmenListDetails[i]
                                .bloodMeasurementValue
                            : ""
                        : "",
              urine_measurement:
                data.labBiomarkerAssessmenListDetails[i].urineMeasurement !=
                null
                  ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement
                  : "",

              urine_measurement_value_l:
                data.labBiomarkerAssessmenListDetails[i]
                  .urineMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .urineMeasurement === 1
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .urineMeasurementValue
                    : ""
                  : "",

              urine_measurement_value_ml:
                data.labBiomarkerAssessmenListDetails[i]
                  .urineMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .urineMeasurement === 2
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .urineMeasurementValue
                    : ""
                  : "",

              urine_measurement_value_nl:
                data.labBiomarkerAssessmenListDetails[i]
                  .urineMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .urineMeasurement === 3
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .urineMeasurementValue
                    : ""
                  : "",
                urine_measurement_value_ng:
                    data.labBiomarkerAssessmenListDetails[i]
                        .urineMeasurementValue !== null
                        ? data.labBiomarkerAssessmenListDetails[i]
                            .urineMeasurement === 4
                            ? data.labBiomarkerAssessmenListDetails[i]
                                .urineMeasurementValue
                            : ""
                        : "",

                urine_measurement_value_mmol:
                    data.labBiomarkerAssessmenListDetails[i]
                        .urineMeasurementValue !== null
                        ? data.labBiomarkerAssessmenListDetails[i]
                            .urineMeasurement === 5
                            ? data.labBiomarkerAssessmenListDetails[i]
                                .urineMeasurementValue
                            : ""
                        : "",
              creatinine_measurement:
                data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurement !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .creatinineMeasurement
                  : "",

              creatinine_measurement_value_l:
                data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .creatinineMeasurement === 1
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .creatinineMeasurementValue
                    : ""
                  : "",

              creatinine_measurement_value_ml:
                data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .creatinineMeasurement === 2
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .creatinineMeasurementValue
                    : ""
                  : "",

              creatinine_measurement_value_nl:
                data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurementValue !== null
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .creatinineMeasurement === 3
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .creatinineMeasurementValue
                    : ""
                  : "",

                  creatinine_measurement_value_dl:
                  data.labBiomarkerAssessmenListDetails[i]
                    .creatinineMeasurementValue !== null
                    ? data.labBiomarkerAssessmenListDetails[i]
                        .creatinineMeasurement === 4
                      ? data.labBiomarkerAssessmenListDetails[i]
                          .creatinineMeasurementValue
                      : ""
                    : "",


              q31biomarkerEmpty: false,
              q31assessmentEmpty: false,
              q31specimenEmpty: false,
              q31measurementEmpty: false,
              q31assessmentDateEmptyError: false,
              q31assessmentDateInvalid: false,
              q31AssessmentDateUnkEmpty: false,
              q31measurementCSFEmpty: false,
              q31measurementUrineEmpty: false,
              q31measurementCreatinineEmpty: false,
              q31measurementInvalid: false,
              q31measurementUrineInvalid: false,
              q31measurementCreatinineInvalid: false,
            };

            dataarray.push(datacomponent);
          }
          setlabbiomarkerassessmentDetails(dataarray);
        }
        //#endregion

      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch {}
  };

  const SavePage = async (validate) => {
    try {
        if (!patientLocked) {
            //Reset Errors
            let isValid = validate ? Validate() : true;

            if (!isValid) {
                setShowTopErrMsg(true);
                return false;
            }
            setShowTopErrMsg(false);
            if (pidRef.current > 0) {
                const data = {
                    LabAssessmentModel: {
                        LoggedInUserId: loggedInUserId,
                        Patientid: pidRef.current,
                        IsValidated: validate,
                        IsAdmin: IsAdmin(),
                        LabBiomarkerAssessmenListDetails: [],
                        LabRenalAssessmenListDetails: [],
                        LabChronicKidneyListDetails: [],
                        LabAssessmentListDetails: [],
                        LabRenalSettingCareDetails: [],
                        LabAssessmentMdeDetails: [],
                    },
                };
                //#region Q31
                if (labbiomarkerassessmentDetails.length > 0) {
                    for (const biomarkerAssessment of labbiomarkerassessmentDetails) {
                        let biomarkerAssessmentData = {
                            labBiomarkerAssessmentID:
                                biomarkerAssessment.labbiomarkerassessmentid,
                            assessmentNumber: biomarkerAssessment.assessmentnumber,
                            biomarker: biomarkerAssessment.biomarker,
                            assessmentStart: biomarkerAssessment.startAssessment,
                            assessmentStartDate: biomarkerAssessment.startAssessment_dt,
                            assessmentStartDateEstimated:
                                biomarkerAssessment.startAssessment_dt_estimated,
                            assessmentStartDateUnknown:
                                biomarkerAssessment.startAssessmentUnkLTLKT,
                            specimen: biomarkerAssessment.specimen,
                            bloodMeasurement: biomarkerAssessment.blood_measurement,
                            bloodMeasurementValue:
                                biomarkerAssessment.blood_measurement === 1
                                    ? biomarkerAssessment.blood_measurement_value_l
                                    : biomarkerAssessment.blood_measurement === 2
                                        ? biomarkerAssessment.blood_measurement_value_ml
                                        : biomarkerAssessment.blood_measurement === 3
                                            ? biomarkerAssessment.blood_measurement_value_nl
                                            : biomarkerAssessment.blood_measurement === 4
                                                ? biomarkerAssessment.blood_measurement_value_ng
                                                : "",
                            urineMeasurement: biomarkerAssessment.urine_measurement,
                            urineMeasurementValue:
                                biomarkerAssessment.urine_measurement === 1
                                    ? biomarkerAssessment.urine_measurement_value_l
                                    : biomarkerAssessment.urine_measurement === 2
                                        ? biomarkerAssessment.urine_measurement_value_ml
                                        : biomarkerAssessment.urine_measurement === 3
                                            ? biomarkerAssessment.urine_measurement_value_nl
                                            : biomarkerAssessment.urine_measurement === 4
                                                ? biomarkerAssessment.urine_measurement_value_ng
                                                : biomarkerAssessment.urine_measurement === 5
                                                    ? biomarkerAssessment.urine_measurement_value_mmol
                                                    : "",
                            creatinineMeasurement: biomarkerAssessment.creatinine_measurement,
                            creatinineMeasurementValue:
                                biomarkerAssessment.creatinine_measurement === 1
                                    ? biomarkerAssessment.creatinine_measurement_value_l
                                    : biomarkerAssessment.creatinine_measurement === 2
                                        ? biomarkerAssessment.creatinine_measurement_value_ml
                                        : biomarkerAssessment.creatinine_measurement === 3
                                            ? biomarkerAssessment.creatinine_measurement_value_nl
                                            : biomarkerAssessment.creatinine_measurement === 4
                                                ? biomarkerAssessment.creatinine_measurement_value_dl
                                                : "",
                        };
                        data.LabAssessmentModel.LabBiomarkerAssessmenListDetails.push(
                            biomarkerAssessmentData
                        );
                    }
                }
                //#region Q31

                ToggleLoader(true);
                const response = await laboratoryAssessmentService.SaveMMALabData(
                    data.LabAssessmentModel
                );
                ToggleLoader(false);
                if (response.status !== HTTPResponse.OK) {
                    if (response?.status === HTTPResponse.Unauthorized) {
                        HandleSessionTimeout();
                    } else throw response.error;
                } else {
                    ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                    // await LoadData();
                    if (response) {
                        const { data } = response;
                        if (data) {
                            SetAssessmentFields(data);
                        }
                    }
                }
            }
        }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const SetAssessmentFields = (data) => {
    //#region Q31
    if (
      data.labBiomarkerAssessmenListDetails !== null &&
      data.labBiomarkerAssessmenListDetails.length > 0
    ) {
      let i = 0;
      let dataarray = [];
      for (i; i < data.labBiomarkerAssessmenListDetails.length; i++) {
        let datacomponent = {
          labbiomarkerassessmentid:
            data.labBiomarkerAssessmenListDetails[i].labBiomarkerAssessmentID !=
            null
              ? data.labBiomarkerAssessmenListDetails[i]
                  .labBiomarkerAssessmentID
              : 0,
          assessmentnumber:
            data.labBiomarkerAssessmenListDetails[i].assessmentNumber,
          biomarker:
            data.labBiomarkerAssessmenListDetails[i].bioMarker !== null
              ? data.labBiomarkerAssessmenListDetails[i].bioMarker
              : "",

          startAssessment:
            data.labBiomarkerAssessmenListDetails[i].assessmentStart !== null
              ? data.labBiomarkerAssessmenListDetails[i].assessmentStart
              : "",
          startAssessment_dt:
            data.labBiomarkerAssessmenListDetails[i].assessmentStartDate !==
            null
              ? data.labBiomarkerAssessmenListDetails[i].assessmentStartDate
              : "",
          startAssessment_dt_estimated:
            data.labBiomarkerAssessmenListDetails[i]
              .assessmentStartDateEstimated !== null
              ? data.labBiomarkerAssessmenListDetails[i]
                  .assessmentStartDateEstimated
              : false,
          startAssessmentUnkLTLKT:
            data.labBiomarkerAssessmenListDetails[i]
              .assessmentStartDateUnknown !== null
              ? data.labBiomarkerAssessmenListDetails[i]
                  .assessmentStartDateUnknown
              : "",

          specimen:
            data.labBiomarkerAssessmenListDetails[i].specimen !== null
              ? data.labBiomarkerAssessmenListDetails[i].specimen
              : "",

          blood_measurement:
            data.labBiomarkerAssessmenListDetails[i].bloodMeasurement !== null
              ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurement
              : "",

          blood_measurement_value_l:
            data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurement === 1
                ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue
                : ""
              : "",

          blood_measurement_value_ml:
            data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurement === 2
                ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue
                : ""
              : "",

          blood_measurement_value_nl:
            data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurement === 3
                ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue
                : ""
                    : "",
            blood_measurement_value_ng:
                data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue !=
                    null
                    ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurement === 4
                        ? data.labBiomarkerAssessmenListDetails[i].bloodMeasurementValue
                        : ""
                    : "",


          urine_measurement:
            data.labBiomarkerAssessmenListDetails[i].urineMeasurement !== null
              ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement
              : "",

          urine_measurement_value_l:
            data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement === 1
                ? data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue
                : ""
              : "",

          urine_measurement_value_ml:
            data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement === 2
                ? data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue
                : ""
              : "",

          urine_measurement_value_nl:
            data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement === 3
                ? data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue
                : ""
              : "",
            urine_measurement_value_ng:
                data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue !=
                    null
                    ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement === 4
                        ? data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue
                        : ""
                    : "",


            urine_measurement_value_mmol:
                data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue !=
                    null
                    ? data.labBiomarkerAssessmenListDetails[i].urineMeasurement === 5
                        ? data.labBiomarkerAssessmenListDetails[i].urineMeasurementValue
                        : ""
                    : "",


          creatinine_measurement:
            data.labBiomarkerAssessmenListDetails[i].creatinineMeasurement !=
            null
              ? data.labBiomarkerAssessmenListDetails[i].creatinineMeasurement
              : "",

          creatinine_measurement_value_l:
            data.labBiomarkerAssessmenListDetails[i]
              .creatinineMeasurementValue !== null
              ? data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurement === 1
                ? data.labBiomarkerAssessmenListDetails[i]
                    .creatinineMeasurementValue
                : ""
              : "",

          creatinine_measurement_value_ml:
            data.labBiomarkerAssessmenListDetails[i]
              .creatinineMeasurementValue !== null
              ? data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurement === 2
                ? data.labBiomarkerAssessmenListDetails[i]
                    .creatinineMeasurementValue
                : ""
              : "",

          creatinine_measurement_value_nl:
            data.labBiomarkerAssessmenListDetails[i]
              .creatinineMeasurementValue !== null
              ? data.labBiomarkerAssessmenListDetails[i]
                  .creatinineMeasurement === 3
                ? data.labBiomarkerAssessmenListDetails[i]
                    .creatinineMeasurementValue
                : ""
              : "",

              creatinine_measurement_value_dl:
              data.labBiomarkerAssessmenListDetails[i]
                .creatinineMeasurementValue !== null
                ? data.labBiomarkerAssessmenListDetails[i]
                    .creatinineMeasurement === 4
                  ? data.labBiomarkerAssessmenListDetails[i]
                      .creatinineMeasurementValue
                  : ""
                : "",

          q31biomarkerEmpty: false,
          q31assessmentEmpty: false,
          q31specimenEmpty: false,
          q31measurementEmpty: false,
          q31assessmentDateEmptyError: false,
          q31assessmentDateInvalid: false,
          q31AssessmentDateUnkEmpty: false,
          q31measurementCSFEmpty: false,
          q31measurementUrineEmpty: false,
          q31measurementCreatinineEmpty: false,
          q31measurementInvalid: false,
          q31measurementUrineInvalid: false,
          q31measurementCreatinineInvalid: false,
        };

        dataarray.push(datacomponent);
      }
      setlabbiomarkerassessmentDetails(dataarray);
    }
    //#endregion

  };

  const validateConcentrationUnits = (
    value,
    unit,
    LitreMinRange,
    litreMaxRange
  ) => {
    let validrange;
    //const minL = 0, maxL = 60000; // Allowed range in Litres

    let volumeInLitres;
    let litreMaxRanges = litreMaxRange;
    volumeInLitres = value;
    // if (unit === "L" || unit === "nl") {
    //   volumeInLitres = value; // No conversion needed
    // } else
    if (unit === "mL") {
      // volumeInLitres = value ; // Convert to Litres
      litreMaxRanges = litreMaxRanges / 1000;
    }

    if (volumeInLitres >= LitreMinRange && volumeInLitres <= litreMaxRanges) {
      validrange = false;
    } else validrange = true;

    return validrange;
  };




// Convert µmol/L → mg/dL
const umolToMgDl = (umolValue) => {
  const conversionFactor = 0.011312; // (Molar Mass / 10,000), M = 113.12 g/mol
  return umolValue * conversionFactor;
};

// Validate if user input falls in serum creatinine range (mg/dL)
const validateCreatinineMgDl = (umolValue, minRange , maxRange ) => {
  
  let validrange;
  const mgDlValue = umolToMgDl(umolValue); //user value umol - mg/dL
  maxRange = umolToMgDl(900); //max value umol 900 to mg/dL
  // return {
  //   isValid: mgDlValue >= minRange && mgDlValue <= maxRange,
  // };

  if (mgDlValue >= minRange && mgDlValue <= maxRange) {
    validrange = false;
  } else validrange = true;

  return validrange;
};


    // Convert µmol/L → ng/mL
    const umolTongML = (umolValue, biomarker) => {
        //ng/mL=µmol/L value×Molecular Weight (g/mol)

        // 1) Methylmalonic acid (MA)
        // Molecular weight: 118.09 g/mol

        // 2) 2-Methylcitrate (2-MC)
        // Molecular weight: 206.15 g/mol

        // 3) 3-Hydroxypropionate (3-HP)
        // Molecular weight: 90.08 g/mol


        let conversionFactor;

        if (biomarker == 1)
            conversionFactor = 118.09;
        else if (biomarker == 2)
            conversionFactor = 206.15;
        else if (biomarker == 3)
            conversionFactor = 90.08;

        return umolValue * conversionFactor;
    };

    // Validate if user input falls in blood range (ng/mL)
    const validatebloodngML = (umolValue, minRange, maxRange, biomarker) => {

        //let validrange;
        //const mgDlValue = umolTongML(umolValue, biomarker); //user value umol - mg/dL
        //maxRange = umolToMgDl(maxRange);


        //if (mgDlValue >= minRange && mgDlValue <= maxRange) {
        //    validrange = false;
        //} else validrange = true;

        return false;// validrange;
    };


    // Convert µmol/L → mmol/mol
    const umolTommol = (umolValue) => {

        const conversionFactor = 10;

        return (umolValue / conversionFactor) * 1000;
    };

    // Validate if user input falls in blood range (mmol/mol)
    const validatebloodmmol = (umolValue, minRange, maxRange) => {

        //let validrange;
        //const mgDlValue = umolTommol(umolValue); //user value umol - mg/dL
        //maxRange = umolTommol(maxRange);


        //if (mgDlValue >= minRange && mgDlValue <= maxRange) {
        //    validrange = false;
        //} else validrange = true;

        return false;// validrange;
    };


  const validateMeasurement = (
    labDetails,
    qarray,
    index,
    maxLimit,
    questionno,
    isValidValue
  ) => {
    let isValid = isValidValue;

    
    //#region Q31
    if (questionno === "Q31") {
      if (labDetails.specimen !== 1) {
        const measurementValue =
          labDetails.blood_measurement === 1
            ? labDetails.blood_measurement_value_l
            : labDetails.blood_measurement === 2
            ? labDetails.blood_measurement_value_ml
                      : labDetails.blood_measurement === 3
                          ? labDetails.blood_measurement_value_nl
                          : labDetails.blood_measurement_value_ng;
        const unit =
          labDetails.blood_measurement === 1
            ? "L"
            : labDetails.blood_measurement === 3
            ? "nl"
                      : labDetails.blood_measurement === 2
                          ? "mL"
                          : "ng";

          if (labDetails.blood_measurement != 4) {

        qarray[index].q31measurementInvalid = validateConcentrationUnits(
          measurementValue,
          unit,
          0,
          maxLimit
              );
          }
          else {
              qarray[index].q31measurementInvalid = validatebloodngML(
                  measurementValue,
                  0,
                  maxLimit,
                  labDetails.bioMarker
              );
          }

        if (qarray[index].q31measurementInvalid) {
          isValid = false;
        }
        
  
      } else {
        const measurementValue =
          labDetails.urine_measurement === 1
            ? labDetails.urine_measurement_value_l
            : labDetails.urine_measurement === 2
            ? labDetails.urine_measurement_value_ml
            : labDetails.urine_measurement_value_nl;
        const unit =
          labDetails.urine_measurement === 1
            ? "L"
            : labDetails.urine_measurement === 3
            ? "nl"
                      : "mL";

      



          if (labDetails.urine_measurement == 4) {
              qarray[index].q31measurementInvalid = validatebloodngML(
                  measurementValue,
                  0,
                  maxLimit,
                  labDetails.bioMarker
              );
          }
          else if (labDetails.urine_measurement == 5) {
              qarray[index].q31measurementUrineInvalid = validatebloodmmol(
                  measurementValue,
                  0,
                  maxLimit
              );
          } else {
              qarray[index].q31measurementUrineInvalid = validateConcentrationUnits(
                  measurementValue,
                  unit,
                  0,
                  maxLimit
              );
          }
        if (qarray[index].q31measurementUrineInvalid) {
          isValid = false;
        }

        const measurementCreatinineValue =
          labDetails.creatinine_measurement === 1
            ? labDetails.creatinine_measurement_value_l

            : labDetails.creatinine_measurement === 2
            ? labDetails.creatinine_measurement_value_ml           
            : labDetails.creatinine_measurement === 3
            ? labDetails.creatinine_measurement_value_nl
            : labDetails.creatinine_measurement_value_dl;
        const cunit =
          labDetails.creatinine_measurement === 1
            ? "L"
            : labDetails.creatinine_measurement === 3
            ? "nl"
            : labDetails.creatinine_measurement === 4
            ? "dl"
            : "mL";
            let molecularurinecreatinine = 900;

            if(labDetails.creatinine_measurement === 4)
            {
                qarray[index].q31measurementCreatinineInvalid = validateCreatinineMgDl(
                  measurementCreatinineValue,
                  0,
                  molecularurinecreatinine
                );
                if (qarray[index].q31measurementCreatinineInvalid) {
                  isValid = false;
                }           
            }
            else if (labDetails.creatinine_measurement != 4) {
        qarray[index].q31measurementCreatinineInvalid =
          validateConcentrationUnits(
            measurementCreatinineValue,
            cunit,
            0,
            molecularurinecreatinine
          );
        if (qarray[index].q31measurementCreatinineInvalid) {
          isValid = false;
        }
      }
      }
    }
    //#endregion


    return isValid;
  };

  const Validate = () => {

    let isValid = true;
    let isQ31Valid = true;
  
    isQ31Valid = ValidateQ31();
 

    if (isQ31Valid)
      isValid = true;
    else isValid = false;

    return isValid;
  };

  const ValidateQ31 = () => {
    let isValid = true;
    let q31array = [...labbiomarkerassessmentDetails];
    for (let i = 0; i < labbiomarkerassessmentDetails.length; i++) {
      if (labbiomarkerassessmentDetails[i].biomarker !== Values.value4) {
        if (labbiomarkerassessmentDetails[i].biomarker === "") {
          q31array[i].q31biomarkerEmpty = true;
          isValid = false;
        }

        if (labbiomarkerassessmentDetails[i].specimen === "") {
          q31array[i].q31specimenEmpty = true;
          isValid = false;
        }

        if (labbiomarkerassessmentDetails[i].startAssessment === "") {
          q31array[i].q31assessmentEmpty = true;
          isValid = false;
        }

        if (
          labbiomarkerassessmentDetails[i].specimen !== 1 &&
          labbiomarkerassessmentDetails[i].blood_measurement === ""
        ) {
          q31array[i].q31measurementEmpty = true;
          isValid = false;
        } else if (
          labbiomarkerassessmentDetails[i].specimen === 1 &&
          (labbiomarkerassessmentDetails[i].urine_measurement === "" ||
            labbiomarkerassessmentDetails[i].creatinine_measurement === "")
        ) {
          q31array[i].q31measurementEmpty = true;
          isValid = false;
        }

        if (
          labbiomarkerassessmentDetails[i].startAssessment === Values.value99 &&
          labbiomarkerassessmentDetails[i].startAssessmentUnkLTLKT === ""
        ) {
          q31array[i].q31AssessmentDateUnkEmpty = true;
          isValid = false;
        }

        const isAssessmentDateBefore =
          dates.oneYr_pretransplant_start &&
          IsDateBefore(
            labbiomarkerassessmentDetails[i].startAssessment_dt,
            dates.oneYr_pretransplant_start
          );

        const isAssessmentDateAfter =
          dates.twenty_four_months_post_stabilization &&
          IsDateAfter(
            labbiomarkerassessmentDetails[i].startAssessment_dt,
            dates.twenty_four_months_post_stabilization
          );

        if (
          labbiomarkerassessmentDetails[i].startAssessment_dt === "Invalid Date"
        ) {
          q31array[i].q31assessmentDateInvalid = true;
        } else if (isAssessmentDateBefore || isAssessmentDateAfter) {
          q31array[i].q31assessmentDateInvalid = true;
        } else {
          q31array[i].q31assessmentDateInvalid = false;
        }

          q31array[i].q31measurementCSFEmpty =
              labbiomarkerassessmentDetails[i].blood_measurement !== "" &&
                  labbiomarkerassessmentDetails[i].blood_measurement !== 99 &&
                  labbiomarkerassessmentDetails[i].blood_measurement_value_l === "" &&
                  labbiomarkerassessmentDetails[i].blood_measurement_value_ml === "" &&
                  labbiomarkerassessmentDetails[i].blood_measurement_value_nl === "" &&
                  labbiomarkerassessmentDetails[i].blood_measurement_value_ng === ""
                  ? true
                  : false;
          q31array[i].q31measurementUrineEmpty =
              labbiomarkerassessmentDetails[i].urine_measurement !== "" &&
                  labbiomarkerassessmentDetails[i].urine_measurement !== 99 &&
                  labbiomarkerassessmentDetails[i].urine_measurement_value_l === "" &&
                  labbiomarkerassessmentDetails[i].urine_measurement_value_ml === "" &&
                  labbiomarkerassessmentDetails[i].urine_measurement_value_nl === "" &&
                  labbiomarkerassessmentDetails[i].urine_measurement_value_ng === "" &&
                  labbiomarkerassessmentDetails[i].urine_measurement_value_mmol === ""
                  ? true
                  : false;
        q31array[i].q31measurementCreatinineEmpty =
          labbiomarkerassessmentDetails[i].creatinine_measurement !== "" &&
          labbiomarkerassessmentDetails[i].creatinine_measurement !== 99 &&
          labbiomarkerassessmentDetails[i].creatinine_measurement_value_l ===
            "" &&
          labbiomarkerassessmentDetails[i].creatinine_measurement_value_ml ===
            "" &&
          labbiomarkerassessmentDetails[i].creatinine_measurement_value_nl ===
            "" && 
          labbiomarkerassessmentDetails[i].creatinine_measurement_value_dl ===
          ""
            ? true
            : false;
        q31array[i].q31assessmentDateEmptyError =
          labbiomarkerassessmentDetails[i].startAssessment === Values.value1 &&
          labbiomarkerassessmentDetails[i].startAssessment_dt === ""
            ? true
            : false;

        if (
          q31array[i].q31measurementCSFEmpty ||
          q31array[i].q31measurementUrineEmpty ||
          q31array[i].q31measurementCreatinineEmpty ||
          q31array[i].q31assessmentDateEmptyError ||
          q31array[i].q31assessmentDateInvalid
        ) {
          isValid = false;
        }

        switch (labbiomarkerassessmentDetails[i].biomarker) {
          case 1:
            isValid = validateMeasurement(
              labbiomarkerassessmentDetails[i],
              q31array,
              i,
              60000,
              "Q31",
              isValid
            );
            break;
          case 2:
            isValid = validateMeasurement(
              labbiomarkerassessmentDetails[i],
              q31array,
              i,
              65,
              "Q31",
              isValid
            );
            break;
          case 3:
            isValid = validateMeasurement(
              labbiomarkerassessmentDetails[i],
              q31array,
              i,
              1200,
              "Q31",
              isValid
            );
            break;
        }
      }
    }

    setlabbiomarkerassessmentDetails(q31array);

    return isValid;
  };



  const handleNumericInputKeyDown = (e) => {
    // Allow backspace, arrow keys, delete, and tab
    if (
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }

    // Prevent non-numeric characters, except '.' (and only allow one decimal point)
    if (
      !/[0-9.]/.test(e.key) ||
      (e.key === "." && e.target.value.includes("."))
    ) {
      e.preventDefault();
      return;
    }

    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const newValue =
      value.slice(0, selectionStart) +
      e.key +
      value.slice(e.target.selectionEnd);

    // Prevent '.' as the first character
    if (e.key === "." && value === "") {
      e.preventDefault();
      return;
    }

    // Allow only two digits after the decimal point
    if (newValue.includes(".") && newValue.split(".")[1].length > 1) {
      e.preventDefault();
    }
  };

  const handleNumericInputKeyDownUpto3 = (e) => {
    // Allow backspace, arrow keys, delete, and tab
    if (
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }
  
    // Prevent non-numeric characters, except '.' (and only allow one decimal point)
    if (
      !/[0-9.]/.test(e.key) ||
      (e.key === "." && e.target.value.includes("."))
    ) {
      e.preventDefault();
      return;
    }
  
    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const newValue =
      value.slice(0, selectionStart) +
      e.key +
      value.slice(e.target.selectionEnd);
  
    // Prevent '.' as the first character
    if (e.key === "." && value === "") {
      e.preventDefault();
      return;
    }
  
    // ✅ Allow only three digits after the decimal point
    if (newValue.includes(".") && newValue.split(".")[1].length > 3) {
      e.preventDefault();
    }
  };
  

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.MMALabAssessment} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() =>
                toggleSidebar(isSideMenuActive, setisSideMenuActive)
              }
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>MMA LAB ASSESSMENTS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}

              <div className="survey-question-section" >
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer grid-overflow">
                    <div
                      className="block-border block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div>
                        <div className="question">
                          <span className="question-weight">Q31.</span>
                          <span className="quest-text-pad question-weight">
                            Please report{" "}
                            <u>all MMA-related biomarker assessments</u> within
                            12 months prior to and 27 months after the index
                            date (from{" "}
                            <span className="indigo-text">
                              {dates.oneYr_pretransplant_start !== null
                                ? dates.oneYr_pretransplant_start
                                : "[1-year pre-transplant start]"}
                            </span>{" "}
                            to{" "}
                            <span className="indigo-text">
                              {dates.twenty_four_months_post_stabilization !=
                              null
                                ? dates.twenty_four_months_post_stabilization
                                : " [24-month post-stabilization date]"}
                            </span>
                            ). <br />
                            Add additional rows for each occurrence of each
                            assessment, as needed.
                            <br />
                            <br />
                            <b> Please note:</b> if a urine MMA-related
                            biomarker assessment is reported, urine creatinine{" "}
                            <u>from the same lab assessment</u> will also be
                            requested to calculate the concentration of the
                            biomarker per urine creatinine.
                          </span>
                        </div>
                        <br></br>
                      </div>
                      {labbiomarkerassessmentDetails &&
                        labbiomarkerassessmentDetails.length > 0 &&
                        labbiomarkerassessmentDetails.map((data, idx) => (
                          <div className="loop-section-ul">
                            <div className="loop-head">
                              <span className="question-weight">
                                {GetOrdinal(idx + 1)} Biomarker Assessment
                              </span>
                              {idx !== 0 && (
                                <div className="delete-btn-div">
                                  <img
                                    width="16px"
                                    src="../Assets/images/Icon-material-delete.png"
                                    alt=""
                                    onClick={() =>
                                      deleteBiomarkerAssessmentDetails(idx)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="containertd grid-overflow"
                              colSpan={3}
                            >
                              <table
                                className="borderTable custom-th-width"
                                style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}
                              >
                                <thead>
                                  <tr>
                                    {/* <th
                                              className="table-th-sec"
                                              >
                                               Assessment Number{" "}
                                                <span className="indigo-text"></span>
                                              </th> */}
                                    <th className="table-th-sec">
                                      Biomarker{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th
                                      className="table-th-sec"
                                      style={{
                                        border: "1px solid",
                                        borderColor: "inherit",
                                        padding: "8px",
                                        textAlign: "center",
                                        // minWidth: "360px",
                                      }}
                                    >
                                      Date of assessment{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Specimen{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Measurement{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    {/* <td className="modal-popup-table-cell">
                                      <div style={{textAlign:"center"}}>{idx + 1}</div>
                                    </td> */}
                                    <td className="modal-popup-table-cell">
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"biomarker-" + idx + "-bio"}
                                            value={1}
                                            checked={
                                              data.biomarker === Values.value1
                                            }
                                            onChange={HandleBioFieldChange}
                                          />
                                          <span className="">
                                            Methylmalonic acid (MA)
                                          </span>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"biomarker-" + idx + "-bio"}
                                            value={2}
                                            checked={
                                              data.biomarker === Values.value2
                                            }
                                            onChange={HandleBioFieldChange}
                                          />
                                          <span className="">
                                            2-methylcitrate (2-MC)
                                          </span>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"biomarker-" + idx + "-bio"}
                                            value={3}
                                            checked={
                                              data.biomarker === Values.value3
                                            }
                                            onChange={HandleBioFieldChange}
                                          />
                                          <span className="">
                                            3-hydroxypropionate (3-HP)
                                          </span>
                                        </label>
                                      </div>
                                      {idx === 0 && (
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"biomarker-" + idx + "-bio"}
                                              value={4}
                                              checked={
                                                data.biomarker === Values.value4
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="">
                                              None of the above assessments
                                              reported
                                            </span>
                                          </label>
                                        </div>
                                      )}

                                      <ErrorField
                                        show={data.q31biomarkerEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>
                                    {data.biomarker === Values.value4 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "startAssessment-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={1}
                                              checked={
                                                data.startAssessment ===
                                                Values.value1
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <span className="">
                                              <DateControl
                                                optionId={"startAssessment_dt"}
                                                ctrlId={
                                                  "startAssessment_dt-" + idx
                                                }
                                                HandleDateChange={
                                                  HandleDateChange
                                                }
                                                date={data.startAssessment_dt}
                                              />
                                            </span>
                                          </label>
                                        </div>
                                        <div className="estimated-date-padding text-margin">
                                          <label>
                                            <input
                                              type="checkbox"
                                              id={idx}
                                              name={
                                                "startAssessment_dt_estimated-" +
                                                idx +
                                                "-bio"
                                              }
                                              checked={
                                                data.startAssessment_dt_estimated
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="radio-text-padding">
                                              Estimated Date
                                            </span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "startAssessment-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={99}
                                              checked={
                                                data.startAssessment ===
                                                Values.value99
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="">
                                              Date unknown
                                            </span>
                                          </label>
                                          <div style={{ marginLeft: "44px" }}>
                                            {dates?.zero_to12months_before_LT_LKT !==
                                              null &&
                                              dates?.zero_to12months_before_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "startAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-bio"
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.startAssessmentUnkLTLKT ===
                                                        Values.value1
                                                      }
                                                      onChange={
                                                        HandleBioFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide012HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      0 to 12 months before
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            {dates?.zero_to_3months_after_LT_LKT !==
                                              null &&
                                              dates?.zero_to_3months_after_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "startAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-bio"
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.startAssessmentUnkLTLKT ===
                                                        Values.value2
                                                      }
                                                      onChange={
                                                        HandleBioFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide03HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      0 to 3 months after LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            {dates?.four_to_15months_after_LT_LKT !==
                                              null &&
                                              dates?.four_to_15months_after_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "startAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-bio"
                                                      }
                                                      value={3}
                                                      checked={
                                                        data.startAssessmentUnkLTLKT ===
                                                        Values.value3
                                                      }
                                                      onChange={
                                                        HandleBioFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide415HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      4 to 15 months after
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            {dates?.sixteen_to_27months_after_LT_LKT !==
                                              null &&
                                              dates?.sixteen_to_27months_after_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "startAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-bio"
                                                      }
                                                      value={4}
                                                      checked={
                                                        data.startAssessmentUnkLTLKT ===
                                                        Values.value4
                                                      }
                                                      onChange={
                                                        HandleBioFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide1627HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      16 to 27 months after
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "startAssessmentUnkLTLKT-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  value={5}
                                                  checked={
                                                    data.startAssessmentUnkLTLKT ===
                                                    Values.value5
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />
                                                <span className="">
                                                  Date completely unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <ErrorField
                                          show={
                                            data.q31assessmentDateEmptyError
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />

                                        <ErrorField
                                          show={data.q31AssessmentDateUnkEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={data.q31assessmentEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={data.q31assessmentDateInvalid}
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    )}

                                    {data.biomarker === Values.value4 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"specimen-" + idx + "-bio"}
                                              value={1}
                                              checked={
                                                data.specimen === Values.value1
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="">Urine</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"specimen-" + idx + "-bio"}
                                              value={2}
                                              checked={
                                                data.specimen === Values.value2
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="">Blood</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"specimen-" + idx + "-bio"}
                                              value={3}
                                              checked={
                                                data.specimen === Values.value3
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="">Plasma</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"specimen-" + idx + "-bio"}
                                              value={4}
                                              checked={
                                                data.specimen === Values.value4
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span className="">Serum</span>
                                          </label>
                                        </div>
                                        {/*<div className="date-field-padding">*/}
                                        {/*  <label className="option-fbox">*/}
                                        {/*    <input*/}
                                        {/*      type="radio"*/}
                                        {/*      id={idx}*/}
                                        {/*      name={"specimen-" + idx + "-bio"}*/}
                                        {/*      value={5}*/}
                                        {/*      checked={*/}
                                        {/*        data.specimen === Values.value5*/}
                                        {/*      }*/}
                                        {/*      onChange={HandleFieldChange}*/}
                                        {/*    />*/}
                                        {/*    <span className="">*/}
                                        {/*      Cerebrospinal fluid (CSF)*/}
                                        {/*    </span>*/}
                                        {/*  </label>*/}
                                        {/*</div>*/}
                                        {/* <ErrorField
                                          show={data.endDateEmptyError}
                                          message={CommonError_Msgs.Msg1}
                                        /> */}

                                        <ErrorField
                                          show={data.q31specimenEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                      </td>
                                    )}

                                    {data.biomarker === Values.value4 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : data.specimen !== 1 ? (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "blood_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={1}
                                              checked={
                                                data.blood_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "blood_measurement_value_l-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.blood_measurement ===
                                                    Values.value1
                                                      ? data.blood_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; µmol/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "blood_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={2}
                                              checked={
                                                data.blood_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "blood_measurement_value_ml-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.blood_measurement ===
                                                    Values.value2
                                                      ? data.blood_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; µmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "blood_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={3}
                                              checked={
                                                data.blood_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "blood_measurement_value_nl-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.blood_measurement ===
                                                    Values.value3
                                                      ? data.blood_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; nmol/mL
                                              </span>
                                            </div>
                                          </label>
                                                            </div>
                                                            <div className="date-field-padding">
                                                                <label className="option-fbox">
                                                                    <input
                                                                        type="radio"
                                                                        id={idx}
                                                                        name={
                                                                            "blood_measurement-" +
                                                                            idx +
                                                                            "-bio"
                                                                        }
                                                                        value={4}
                                                                        checked={
                                                                            data.blood_measurement ===
                                                                            Values.value4
                                                                        }
                                                                        onChange={HandleBioFieldChange}
                                                                    />
                                                                    <div className="option-fbox">
                                                                        <span>
                                                                            <input
                                                                                className="sub-input-dash"
                                                                                id={idx}
                                                                                name={
                                                                                    "blood_measurement_value_ng-" +
                                                                                    idx +
                                                                                    "-bio"
                                                                                }
                                                                                type="text"
                                                                                value={
                                                                                    data.blood_measurement ===
                                                                                        Values.value4
                                                                                        ? data.blood_measurement_value_ng
                                                                                        : ""
                                                                                }
                                                                                maxLength={8}
                                                                                onKeyDown={
                                                                                    handleNumericInputKeyDown
                                                                                }
                                                                                onChange={HandleBioFieldChange}
                                                                            />{" "}
                                                                            &nbsp; ng/mL
                                                                        </span>
                                                                    </div>
                                                                </label>
                                                            </div>


                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "blood_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={99}
                                              checked={
                                                data.blood_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q31measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={data.q31measurementCSFEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={data.q31measurementInvalid}
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label>Urine</label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={1}
                                              checked={
                                                data.urine_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urine_measurement_value_l-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urine_measurement ===
                                                    Values.value1
                                                      ? data.urine_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; µmol/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={2}
                                              checked={
                                                data.urine_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urine_measurement_value_ml-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urine_measurement ===
                                                    Values.value2
                                                      ? data.urine_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; µmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={3}
                                              checked={
                                                data.urine_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urine_measurement_value_nl-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urine_measurement ===
                                                    Values.value3
                                                      ? data.urine_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; nmol/mL 
                                              </span>
                                            </div>
                                          </label>
                                                                </div>

                                                                <div className="date-field-padding">
                                                                    <label className="option-fbox">
                                                                        <input
                                                                            type="radio"
                                                                            id={idx}
                                                                            name={
                                                                                "urine_measurement-" +
                                                                                idx +
                                                                                "-bio"
                                                                            }
                                                                            value={4}
                                                                            checked={
                                                                                data.urine_measurement ===
                                                                                Values.value4
                                                                            }
                                                                            onChange={HandleBioFieldChange}
                                                                        />

                                                                        <div className="option-fbox">
                                                                            <span>
                                                                                <input
                                                                                    className="sub-input-dash"
                                                                                    id={idx}
                                                                                    name={
                                                                                        "urine_measurement_value_ng-" +
                                                                                        idx +
                                                                                        "-bio"
                                                                                    }
                                                                                    type="text"
                                                                                    value={
                                                                                        data.urine_measurement ===
                                                                                            Values.value4
                                                                                            ? data.urine_measurement_value_ng
                                                                                            : ""
                                                                                    }
                                                                                    maxLength={8}
                                                                                    onKeyDown={
                                                                                        handleNumericInputKeyDown
                                                                                    }
                                                                                    onChange={HandleBioFieldChange}
                                                                                />{" "}
                                                                                &nbsp; ng/mL
                                                                            </span>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                <div className="date-field-padding">
                                                                    <label className="option-fbox">
                                                                        <input
                                                                            type="radio"
                                                                            id={idx}
                                                                            name={
                                                                                "urine_measurement-" +
                                                                                idx +
                                                                                "-bio"
                                                                            }
                                                                            value={5}
                                                                            checked={
                                                                                data.urine_measurement ===
                                                                                Values.value5
                                                                            }
                                                                            onChange={HandleBioFieldChange}
                                                                        />

                                                                        <div className="option-fbox">
                                                                            <span>
                                                                                <input
                                                                                    className="sub-input-dash"
                                                                                    id={idx}
                                                                                    name={
                                                                                        "urine_measurement_value_mmol-" +
                                                                                        idx +
                                                                                        "-bio"
                                                                                    }
                                                                                    type="text"
                                                                                    value={
                                                                                        data.urine_measurement ===
                                                                                            Values.value5
                                                                                            ? data.urine_measurement_value_mmol
                                                                                            : ""
                                                                                    }
                                                                                    maxLength={8}
                                                                                    onKeyDown={
                                                                                        handleNumericInputKeyDown
                                                                                    }
                                                                                    onChange={HandleBioFieldChange}
                                                                                />{" "}
                                                                                &nbsp; mmol/mol creatinine
                                                                            </span>
                                                                        </div>
                                                                    </label>
                                                                </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={99}
                                              checked={
                                                data.urine_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={data.q31measurementUrineInvalid}
                                          message={CommonError_Msgs.Msg2}
                                        />
                                        <ErrorField
                                          show={data.q31measurementUrineEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <div className="date-field-padding">
                                          <br />

                                          <label>
                                            Urine creatinine from same urine
                                            sample
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={1}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_l-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value1
                                                      ? data.creatinine_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; µmol/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={2}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_ml-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value2
                                                      ? data.creatinine_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; µmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={3}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_nl-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value3
                                                      ? data.creatinine_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp; nmol/mL 
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={4}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value4
                                              }
                                              onChange={HandleBioFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_dl-" +
                                                    idx +
                                                    "-bio"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value4
                                                      ? data.creatinine_measurement_value_dl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleBioFieldChange}
                                                />{" "}
                                                &nbsp;  mg/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>




                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-bio"
                                              }
                                              value={99}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleBioFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={data.q31measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={
                                            data.q31measurementCreatinineEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q31measurementCreatinineInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))}

                      {labbiomarkerassessmentDetails &&
                        labbiomarkerassessmentDetails[0].biomarker !==
                          Values.value4 && patientLocked===false && (
                          <div>
                            <div
                              className="answer-list-text"
                              onClick={addbiomarkerassessmentRow}
                            >
                              <a>
                                <img
                                  width="18px"
                                  src="../Assets/images/plus.png"
                                  alt=""
                                />
                              </a>
                              <a className="radio-text-padding">
                                Click to add additional rows for MMA-related
                                biomarker assessment
                              </a>
                            </div>
                          </div>
                        )}
                    </div>
                 
                  </div>
                </div>

                <div className="survey-section-content-foot">
                  <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showHide012HyperlinkModal && (
        <InfoPopUp
          description={zeroToTwelve(
            dates?.oneYr_pretransplant_start,
            dates?.oneYr_pretransplant_end
          )}
          OkClick={() => setShowHide012HyperlinkModal(false)}
        />
      )}
      {showHide03HyperlinkModal && (
        <InfoPopUp
          description={zeroToThree(
            dates?.indexDt,
            dates?.three_month_stabilization
          )}
          OkClick={() => setShowHide03HyperlinkModal(false)}
        />
      )}
      {showHide415HyperlinkModal && (
        <InfoPopUp
          description={fourToFifteen(
            dates?.post_stabilization_start,
            dates?.twelve_month_post_stabilization
          )}
          OkClick={() => setShowHide415HyperlinkModal(false)}
        />
      )}
      {showHide1627HyperlinkModal && (
        <InfoPopUp
          description={sixteenToTwentySeven(
            dates?.twelve_month_post_stabilization_plusOneday,
            dates?.twenty_four_months_post_stabilization
          )}
          OkClick={() => setShowHide1627HyperlinkModal(false)}
        />
      )}
    </>
  );
};

export default MMALabAssessment;
